import { Subject, takeUntil } from 'rxjs';
import { CHANNEL_STATUS, DEFAULT_ERROR, ERROR_MESSAGES, activeTranslations } from '../../../../../enum/constants';
import { IError } from '../../../../../interfaces';
import { Channel } from '../../../../../modules/crm/channel/components/channel/channel.interface';
import { ChannelService } from '../../../../../services/channel.service';
import { NotificationService } from '../../../../../services/notifications.service';
import { IntegrationService } from '../../../../../services/integration.service';

export class BaseIntegration {

  constructor(protected readonly integrationService: IntegrationService,
              protected readonly notificationService: NotificationService,
              protected readonly channelService: ChannelService) {
  }

  protected readonly destroy$ = new Subject<null>();
  protected qrUrl?: string;
  protected channel_id!: string;
  protected channel_name: string = '';
  protected username?: string;
  protected name?: string;
  protected phoneNumber?: string;
  protected status: CHANNEL_STATUS = CHANNEL_STATUS.LOADING;
  protected showQr: boolean = false;
  protected isLoader: boolean = false;
  protected isConnectionProcessed: boolean = false;
  protected isPhoneInputDisabled: boolean = false;
  protected isHandleFiles: boolean = false;
  protected channel?: Channel;
  protected hasLoadedChannel = false;


  protected deleteChannel(): void {
    this.isLoader = true;
    this.integrationService.disconnect(this.channel_id)
      .subscribe({
        next: () => {
          this.getChannelById();
        },
        error: (e) => {
          (e.error?.errors || []).forEach((err: IError) => {
            this.notificationService.showError(activeTranslations.notifications_texts.error.error, ERROR_MESSAGES[err.code] || DEFAULT_ERROR);
          });
          this.isLoader = false;
        },
      });
  }

  protected getChannelById(): void {
    this.isLoader = !this.hasLoadedChannel;
    this.channelService.getChannelById(this.channel_id)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (channel: Channel) => {
          this.channel = channel;
          this.channel_name = channel.name;
          this.status = channel.status;
          this.isLoader = false;
          this.hasLoadedChannel = true;
          if (channel.x_data) {
            this.username = channel.x_data['username'];
            this.name = channel.x_data['name'];
            this.phoneNumber = channel.x_data['number'];
            this.isHandleFiles = channel.x_data['is_handle_files'] ?? false;
          }
          this.channelByIdCallback();
        },
        error: (e): void => {
          this.isLoader = false;
          this.hasLoadedChannel = true;
          (e.error?.errors || []).forEach((err: IError) => {
            this.notificationService.showError(activeTranslations.notifications_texts.error.error, ERROR_MESSAGES[err.code] || DEFAULT_ERROR);
          });
        },
      });
  }


  protected openWindow() {
    const newWindow = window.open(
      this.qrUrl,
      '_blank',
      'left=0,top=0,width=0,height=0',
    );

    newWindow?.focus();
  }

  protected copyConnectUrlToClipboard() {
    const data = this.qrUrl;
    if (data) {
      navigator.clipboard.writeText(data).then(() => {
        this.notificationService.showSuccess('', activeTranslations.notifications_texts.info.copied);
      }).catch(_ => {
        this.notificationService.showError('', activeTranslations.notifications_texts.error.there_was_an_error_please_try_again);
      });
    }
  }

  protected channelByIdCallback(): void {

  }

  protected copyChannelId() {
    const data = this.channel_id;
    navigator.clipboard.writeText(data).then(() => {
      this.notificationService.showSuccess('', activeTranslations.notifications_texts.info.copied);
    }).catch(_ => {
      this.notificationService.showError('', activeTranslations.notifications_texts.error.there_was_an_error_please_try_againn);
    });
  }

  protected isHandleFilesChanged(handle: any) {
    this.isHandleFiles = handle?.checked ?? false;
  }
}
